import React from 'react';
import { reduxForm, Field } from 'redux-form';
import InputField from './InputField';
import FormError from './FormError';
import { formatSaveStatus } from '../helpers/formatters';

const fieldsArray = ['first_name', 'last_name', 'mdn', 'user_profile'];

let SearchSubsForm = ({
  handleSubmit,
  saveStatus,
  error,
  fields = fieldsArray,
}) => (
  <form onSubmit={handleSubmit}>
    {fields.includes('first_name') && (
      <Field component={InputField} name="first_name" label="First Name" />
    )}
    {fields.includes('last_name') && (
      <Field component={InputField} name="last_name" label="Last Name" />
    )}
    {fields.includes('mdn') && (
      <Field component={InputField} name="mdn" label="MDN" />
    )}
    {fields.includes('device_sn') && (
      <Field component={InputField} name="device_sn" label="Device SN" />
    )}
    {fields.includes('user_profile') && (
      <Field
        component={InputField}
        name="user_profile"
        label="User Profile ID"
      />
    )}
    {fields.includes('icc_id') && (
      <Field component={InputField} name="icc_id" label="ICC ID" />
    )}
    {fields.includes('device_id') && (
      <Field component={InputField} name="device_id" label="Device Id" />
    )}
    {fields.includes('imsi') && (
      <Field component={InputField} name="imsi" label="IMSI" />
    )}
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
      Search Subscriptions
    </button>
    <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
  </form>
);

SearchSubsForm = reduxForm({
  form: 'searchSubs',
})(SearchSubsForm);

export default SearchSubsForm;
